export default "__VITE_ASSET__BoAxB33T__"